const ROOT_DOMAIN = 'utrsports.net';

export const isSafeReturnUrl = (value) => {
    if (!value || typeof value !== 'string') {
        return false;
    }
    let url;
    try {
        url = new URL(value);
    } catch (error) {
        return false;
    }
    if (url.protocol !== 'https:' || url.username || url.password) {
        return false;
    }
    return url.hostname === ROOT_DOMAIN || url.hostname.endsWith(`.${ROOT_DOMAIN}`);
};

export const appendCode = (returnUrl, code) => {
    const url = new URL(returnUrl);
    url.searchParams.set('code', code);
    return url.toString();
};
